
import Vue from 'vue';
import {Route} from 'vue-router';
import TitleBar from './components/title-bar.vue';
import {mapActions, mapMutations, mapGetters} from 'vuex';
import ITitlebarOptions from '../interfaces/ititlebar-options';
import app from './app.vue';
    import { TitlebarAction } from '../interfaces/titlebar-action-enum';
import locationSearch from './views/location-search.vue';

declare const window: any;

export default Vue.extend({
  name: 'app',
  components: {'title-bar': TitleBar},
  data() {
    return {
      titleBar: {} as ITitlebarOptions
    };
  },
  computed:{
      ...mapGetters(['getWidgetTitle', 'getCurrentUser'])
  },
  watch: {
    $route(to: Route, from: Route) {
      this.navigate();
      const dest = to?.name ?? 'Locations';
      const alkBodyElement = document.querySelector('body.alk-body');
      if (!alkBodyElement) throw Error('AlkBody element not found');
      // Assigning the body id here to account for the styles
      switch (dest) {
        case 'locations':
          alkBodyElement.setAttribute('id', 'page_location_search');
          break;
        case 'search':
          alkBodyElement.setAttribute('id', 'page_location_search');
          break;
        case 'list':
          alkBodyElement.setAttribute('id', 'page_location_list');
          break;
        case 'filters':
          alkBodyElement.setAttribute('id', '');
          break;
        case 'details':
          alkBodyElement.setAttribute('id', 'page_location_details');
          break;
      }
    }
  },
  methods: {
      ...mapActions(['getMobileMaxSearchResults', 'getLocationSearchTypesAsync', 'getWidgetTitleAsync', 'getCurrentUserAsync']),
    ...mapMutations(['setIsLoading', 'setHasError']),
    navigate() {
      this.titleBar = this.$route?.meta?.titlebarOptions;
      if(this.titleBar){
        this.titleBar.title = this.getWidgetTitle ?? 'Locations';
        }
        if (this.titleBar && (this.getCurrentUser === null || typeof this.getCurrentUser === 'undefined')){
            this.titleBar.left = {
                button: TitlebarAction.back,
                callback: () => { window.location.href = "/Mobile/Authentication" }
            }
        }
      }
  },

  async mounted() {
    this.setIsLoading(true);
    try {
      window.$app = this;
      this.navigate();
      await this.getCurrentUserAsync();
      await this.getWidgetTitleAsync();
      await this.getMobileMaxSearchResults();
      await this.getLocationSearchTypesAsync();
      this.$router.replace({name: 'search'});
    } catch (e) {
      this.setHasError(true);
    } finally {
      this.setIsLoading(false); 
    }
  }
});
